import apiClient from "../utils/apiClient.util";

export const fetchAllProjects = async (
  page = 1,
  limit = 10,
  status,
  search
) => {
  try {
    const offset = page;
    const params = {
      limit,
      offset,
      orderDirection: -1,
      orderField: "createdAt",
      saleStatus: status !== null ? status : undefined,
      search: search !== "" ? search : undefined,
      isLive: true,
    };

    const response = await apiClient.get("/pro-projects/get", { params });
    return response.data;
  } catch (error) {
    console.error("Fetch all projects API error:", error);
    throw error;
  }
};
